export default __webpack_public_path__ + "static/media/Pixo VR.6daa3e66.png";